// extracted by mini-css-extract-plugin
export default {"errorWrapper":"Fallback_errorWrapper__zGCYS"};